import _ from 'lodash';

import { FileWithPreview, core, toJSON, toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  imageUploadsInProgress: number;
  businessImages: core.UploadedImage[];
  imagesToBeCropped: FileWithPreview[];
  imageFetchInProgress: boolean;
  profileImages: core.UploadedImage[];
  profileImageRequestInProgress: boolean;
  ticketTypeImages: {
    [id: number]: core.UploadedImage[];
  };
  ticketTypeImageRequestInProgress: boolean;
}

const initialState = {
  imageUploadsInProgress: 0,
  businessImages: [],
  imagesToBeCropped: [],
  imageFetchInProgress: false,
  profileImages: [],
  profileImageRequestInProgress: false,
  ticketTypeImages: {},
  ticketTypeImageRequestInProgress: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload, context } = action;
  switch (type) {
    case AppConstants.IMAGE_FETCH_ALL_BUSINESS_IMAGE_STARTING:
      return {
        ...state,
        imageFetchInProgress: true,
      };
    case AppConstants.IMAGE_FETCH_ALL_BUSINESS_IMAGE_FAILED:
      return {
        ...state,
        businessImages: initialState.businessImages,
        imageFetchInProgress: false,
      };
    case AppConstants.IMAGE_FETCH_ALL_BUSINESS_IMAGE_DONE:
      return {
        ...state,
        businessImages: toJSONArray<core.UploadedImage>(payload),
        imageFetchInProgress: false,
      };
    case AppConstants.IMAGE_UPLOAD_STARTING:
      return {
        ...state,
        imageUploadsInProgress: state.imageUploadsInProgress + 1,
      };
    case AppConstants.IMAGE_UPLOAD_DONE: {
      const newlyUploadedImage = toJSON<core.UploadedImage>(payload);
      return {
        ...state,
        businessImages: [newlyUploadedImage, ...state.businessImages],
        imageUploadsInProgress: state.imageUploadsInProgress - 1,
      };
    }
    case AppConstants.IMAGE_UPLOAD_FAILED:
      return {
        ...state,
        imageUploadsInProgress: state.imageUploadsInProgress - 1,
      };

    case AppConstants.IMAGE_ADD_IMAGES_TO_BE_CROPPED: {
      const filesToAdd = _.map(payload, (file) => {
        file.preview = URL.createObjectURL(file);
        return file;
      });
      return {
        ...state,
        imagesToBeCropped: [...state.imagesToBeCropped, ...filesToAdd],
      };
    }

    case AppConstants.IMAGE_REMOVE_IMAGE_TO_BE_CROPPED: {
      const imagesToBeCropped = _.filter(state.imagesToBeCropped, (file: FileWithPreview) => {
        if (file === payload && file.preview) {
          URL.revokeObjectURL(file.preview);
        }
        return file !== payload;
      });
      return {
        ...state,
        imagesToBeCropped,
      };
    }

    case AppConstants.IMAGE_FETCH_ALL_BUSINESS_PROFILE_IMAGES_STARTING:
    case AppConstants.IMAGE_UPSERT_BUSINESS_PROFILE_IMAGES_STARTING: {
      return {
        ...state,
        profileImageRequestInProgress: true,
      };
    }
    case AppConstants.IMAGE_FETCH_ALL_BUSINESS_PROFILE_IMAGES_DONE:
    case AppConstants.IMAGE_UPSERT_BUSINESS_PROFILE_IMAGES_DONE: {
      return {
        ...state,
        profileImageRequestInProgress: false,
        profileImages: toJSONArray<core.UploadedImage>(payload),
      };
    }
    case AppConstants.IMAGE_FETCH_ALL_BUSINESS_PROFILE_IMAGES_FAILED:
    case AppConstants.IMAGE_UPSERT_BUSINESS_PROFILE_IMAGES_FAILED: {
      return {
        ...state,
        profileImageRequestInProgress: false,
        profileImages: [],
      };
    }

    case AppConstants.IMAGE_FETCH_ALL_TICKET_TYPE_IMAGES_STARTING:
    case AppConstants.IMAGE_UPSERT_TICKET_TYPE_IMAGES_STARTING: {
      return {
        ...state,
        ticketTypeImageRequestInProgress: true,
      };
    }
    case AppConstants.IMAGE_FETCH_ALL_TICKET_TYPE_IMAGES_DONE:
    case AppConstants.IMAGE_UPSERT_TICKET_TYPE_IMAGES_DONE: {
      return {
        ...state,
        ticketTypeImageRequestInProgress: false,
        ticketTypeImages: {
          ...state.ticketTypeImages,
          [context?.id]: toJSONArray<core.UploadedImage>(payload).sort(
            (a, b) => a.orderingIndex - b.orderingIndex
          ),
        },
      };
    }
    case AppConstants.IMAGE_FETCH_ALL_TICKET_TYPE_IMAGES_FAILED:
    case AppConstants.IMAGE_UPSERT_TICKET_TYPE_IMAGES_FAILED: {
      return {
        ...state,
        ticketTypeImageRequestInProgress: false,
        ticketTypeImages: {
          ...state.ticketTypeImages,
          [context?.id]: [],
        },
      };
    }

    default: {
      return state;
    }
  }
}
